import { render } from "./OnPointDumpsterPlacement.vue?vue&type=template&id=1c1f62c5"
import script from "./OnPointDumpsterPlacement.vue?vue&type=script&lang=js"
export * from "./OnPointDumpsterPlacement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__